/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { dataSearchState } from "../state";
import Tooltip from "Components/common/Tooltip";
import { verifyBulkActionPerformedAndAllow } from "../DataSearchUtils";

const AddRemoveValue = observer(props => {
  const {
    defaultValue = [],
    store = [],
    id = "",
    listKey,
    setTableLoading = () => { }
  } = props || {};

  const [updatedDefaultValue, setUpdatedDefaultValue] = useState(defaultValue);

  const constructLocationModelPayload = updatedFilteredList => {
    const country = [];
    const state = [];
    const city = [];
    const temp = [...updatedFilteredList];
    temp?.length > 0 &&
      temp.map(item => {
        const key = Object.keys(item)[0];
        if (key === "state") {
          state.push(item?.[key]?.[0]);
        } else if (key === "country") {
          country.push(item?.[key]?.[0]);
        } else {
          city.push(item?.[key]?.[0]);
        }
      });
    const finalList = {
      country: country.filter(Boolean),
      state: state.filter(Boolean),
      city: city.filter(Boolean)
    };
    return finalList;
  };

  const constructCompanyLocationModelPayload = updatedFilteredList => {
    const companyCountry = [];
    const companyState = [];
    const companyCity = [];
    const temp = [...updatedFilteredList];
    temp?.length > 0 &&
      temp.map(item => {
        const key = Object.keys(item)[0];
        if (key === "state") {
          companyState.push(item?.[key]?.[0]);
        } else if (key === "country") {
          companyCountry.push(item?.[key]?.[0]);
        } else {
          companyCity.push(item?.[key]?.[0]);
        }
      });
    const finalList = {
      companyCountry: companyCountry.filter(Boolean),
      companyState: companyState.filter(Boolean),
      companyCity: companyCity.filter(Boolean)
    };
    return finalList;
  };

  const constructKeywordModelPayload = (updatedFilteredList = [], keywordId) => {
    const keywords = [];
    const temp = [...updatedFilteredList];
    temp?.length > 0 &&
      temp.map(item => {
        const key = Object.keys(item)?.[0];
        if (key === "keywords") {
          keywords.push(item?.[key]?.[0]);
        }
      });
    return { [keywordId]: keywords.filter(Boolean) };
  };

  const constructAutoCompletePayload = item => {
    const performAction = () => {
      let tempData = [...dataSearchState?.selectedFilteredList?.[id]];
      const updatedFilteredData = tempData.filter(filterData => {
        const updatedFilterData =
          id === "companyDomain"
            ? filterData?.name || filterData?.primaryDomain
            : filterData.name;
        return updatedFilterData !== item;
      });

      dataSearchState.setSelectedFilteredList({
        ...dataSearchState.selectedFilteredList,
        [id]: updatedFilteredData
      });

      const updatedFilteredList = updatedFilteredData
        ?.map(item => {
          if (item.checked) {
            return id === "companyDomain"
              ? item?.primaryDomain
              : { [item?.group]: item?.searchText };
          }
        })
        ?.filter(Boolean);

      if (id === "companyDomain") {
        dataSearchState.setFilterComponentData({
          ...dataSearchState.filterComponentData,
          [id]: updatedFilteredList
        });
      } else {
        const finalList =
          id?.toLowerCase() === "location"
            ? constructLocationModelPayload(updatedFilteredList)
            : id?.toLowerCase() === "companylocation"
              ? constructCompanyLocationModelPayload(updatedFilteredList)
              : ["keywords", "companykeywords", "contactkeywords"].includes(id?.toLowerCase())
                ? constructKeywordModelPayload(updatedFilteredList, id)
                : { [id]: updatedFilteredData.map(d => (typeof d === "object" && d != null) ? (d.id || d.name) : d) }; // For industry, profileBadge, level, or others
        dataSearchState.setFilterComponentData({
          ...dataSearchState.filterComponentData,
          ...finalList
        });
      }
    };
    if (["bulk", "custom"].includes(dataSearchState?.rangeSelected?.type)) {
      verifyBulkActionPerformedAndAllow(performAction);
    } else {
      performAction();
    }
  };

  const onCloseIconClick = item => {
    const performAction = () => {
      if (id === "name" && listKey) {
        const key = listKey;
        const cur = store?.filterComponentData?.[key];
        const arr = Array.isArray(cur) ? cur : [];
        const updated = arr.filter(v => v !== item);
        store.setFilterComponentData({ ...store.filterComponentData, [key]: updated });
        return;
      }
      if (id?.toLowerCase() === "companydomain" && typeof item === "string") {
        const key = listKey || id;
        if (
          (key === "companyDomainList" && item === "Company Domain List") ||
          (key === "companyNameList" && item === "Company Name List") ||
          (key === "companyLinkedInList" && item === "LinkedIn URL List")
        ) {
          store.setFilterComponentData({ ...store.filterComponentData, [key]: [] });
          dataSearchState.setSelectedFilteredList({ ...dataSearchState.selectedFilteredList, [id]: [] });
          return;
        }
        const updated = (store?.filterComponentData?.[key] || []).filter(v => v !== item);
        store.setFilterComponentData({ ...store.filterComponentData, [key]: updated });
        dataSearchState.setSelectedFilteredList({ ...dataSearchState.selectedFilteredList, [id]: [] });
        return;
      }
      if (
        ["location", "companylocation", "companydomain", "keywords", "companykeywords", "contactkeywords", "industry", "technologies"]?.includes(id?.toLowerCase())
      ) {
        constructAutoCompletePayload(item);
      } else {
        const updatedFilteredData = store?.filterComponentData?.[id].filter(
          filterData => filterData !== item
        );
        store.setFilterComponentData({
          ...store.filterComponentData,
          [id]: updatedFilteredData
        });
      }
    };
    if (["bulk", "custom"].includes(dataSearchState?.rangeSelected?.type)) {
      verifyBulkActionPerformedAndAllow(performAction);
    } else {
      performAction();
    }
  };

  const handleClearAll = () => {
    const performAction = () => {
      if (id?.toLowerCase() === "location") {
        dataSearchState.setSelectedFilteredList({
          ...dataSearchState.selectedFilteredList,
          [id]: []
        });
        dataSearchState.setFilterComponentData({
          ...dataSearchState.filterComponentData,
          country: [],
          state: [],
          city: []
        });
      } else if (id?.toLowerCase() === "companylocation") {
        dataSearchState.setSelectedFilteredList({
          ...dataSearchState.selectedFilteredList,
          [id]: []
        });
        dataSearchState.setFilterComponentData({
          ...dataSearchState.filterComponentData,
          companyCountry: [],
          companyState: [],
          companyCity: []
        });
      } else if (["keywords", "companykeywords", "contactkeywords", "industry", "technologies"].includes(id?.toLowerCase())) {
        dataSearchState.setSelectedFilteredList({
          ...dataSearchState.selectedFilteredList,
          [id]: []
        });
        dataSearchState.setFilterComponentData({
          ...dataSearchState.filterComponentData,
          [id]: []
        });
      } else if (id === "companyDomain") {
        const key = listKey || id;
        dataSearchState.setSelectedFilteredList({
          ...dataSearchState.selectedFilteredList,
          [id]: []
        });
        dataSearchState.setFilterComponentData({
          ...dataSearchState.filterComponentData,
          [key]: []
        });
      } else if (id === "name" && listKey) {
        dataSearchState.setFilterComponentData({
          ...dataSearchState.filterComponentData,
          [listKey]: []
        });
      } else {
        dataSearchState.setFilterComponentData({
          ...dataSearchState.filterComponentData,
          [id]: []
        });
      }
    };
    if (["bulk", "custom"].includes(dataSearchState?.rangeSelected?.type)) {
      verifyBulkActionPerformedAndAllow(performAction);
    } else {
      performAction();
    }
  };

  useEffect(() => {
    if (["companydomain", "location", "companylocation", "keywords", "companykeywords", "contactkeywords", "industry", "technologies"].includes(id?.toLowerCase())) {
      if (defaultValue?.length > 0) {
        const updatedDefaultValue = defaultValue.map(item => {
          if (id === "companyDomain") {
            return typeof item === "string" ? item : (item?.checked ? (item?.name || item?.primaryDomain) : null);
          } else {
            return item?.checked ? (item?.name || item) : null;
          }
        }).filter(Boolean);
        setUpdatedDefaultValue(updatedDefaultValue);
      } else {
        setUpdatedDefaultValue(defaultValue);
      }
    } else {
      setUpdatedDefaultValue(defaultValue);
    }
  }, [defaultValue, id, listKey]);

  return (
    updatedDefaultValue?.length > 0 && (
      <section className="addRemoveValue">
        <span className="horizontalBorderLine" />
        <div className="flexCenterWithJustifyContent">
          <div className="addRemoveValueWrapper">
            {updatedDefaultValue?.map((item, idx) => {
              const displayItem = typeof item === 'object' ? (item?.name || item?.id) : item;
              return (
                <div className="tagItem" key={`${displayItem}-${idx}`}>
                  <span className="selectedTag">{displayItem}</span>
                  <i
                    className="material-icons selectedTagCloseIcon"
                    onClick={() => onCloseIconClick(item)}
                  >
                    close
                  </i>
                </div>
              );
            })}
          </div>
          <div className="clearAll">
            <Tooltip tooltip="Clear all" placement="left">
              <i
                className="material-icons clearAllIcon"
                onClick={handleClearAll}
              >
                clear_all
              </i>
            </Tooltip>
          </div>
        </div>
      </section>
    )
  );
});

export { AddRemoveValue };
export default AddRemoveValue;
